export default __webpack_public_path__ + "static/media/success.5ec9e2d8.svg";